(function () {
    'use strict';
    angular.module('wamasysApp').factory('NativeTicketApi', NativeTicketApi);
    NativeTicketApi.$inject = ['$http'];
    function NativeTicketApi($http) {
        var base = 'api/native-tickets';
        function data(response) { return response.data; }
        return {
            get: function (path, params) { return $http.get(base + (path ? '/' + path : ''), {params: params}).then(data); },
            post: function (path, value) { return $http.post(base + (path ? '/' + path : ''), value).then(data); },
            preview: function (value) { return $http.post(base + '/preview', {markdown: value || ''}).then(data); },
            uuid: function () {
                // Identifiant stable pour les relances ; les droits restent contrôlés sur le serveur.
                var bytes = new Uint8Array(16);
                if (window.crypto && window.crypto.getRandomValues) { window.crypto.getRandomValues(bytes); }
                else { for (var i = 0; i < bytes.length; i++) { bytes[i] = Math.floor(Math.random() * 256); } }
                bytes[6] = (bytes[6] & 15) | 64; bytes[8] = (bytes[8] & 63) | 128;
                var hex = Array.prototype.map.call(bytes, function (b) { return ('0' + b.toString(16)).slice(-2); }).join('');
                return hex.slice(0, 8) + '-' + hex.slice(8, 12) + '-' + hex.slice(12, 16) + '-' + hex.slice(16, 20) + '-' + hex.slice(20);
            }
        };
    }
    angular.module('wamasysApp').config(['$stateProvider', function ($stateProvider) {
        $stateProvider.state('native-tickets', {
            parent: 'entity', url: '/tickets?ticketId&contractId&areaId',
            data: {authenticate: true, authorities: [], pageTitle: 'Tickets et tâches'},
            views: {'content@': {templateUrl: 'app/business/teamwork/native-tickets.html', controller: 'NativeTicketsController', controllerAs: 'vm'}}
        });
    }]);
})();
